import styled from 'styled-components';
import { theme } from '@/components/features/theme/theme';

export const StyledScrollAnimation = styled.section`
	background: ${props => props.color || '#fff'};
	padding: 80px 0;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: 100svh;
	z-index: 3;
	.global-image {
		width: 80%;
		margin: 0 auto;
	}
	@media (max-width: 992px) {
		min-height: unset;
		padding: 80px 0;
		svg {
			height: auto;
		}
	}

	.ygen-logo {
		svg {
			height: 180px;
		}
	}
	#Phoenix_Line,
	#Yokogawa_Line,
	#Baumer_Line,
	#Jumo_Line,
	#Beamex_Line,
	#Wika_Line,
	#Leser_Line,
	#Bray_Line,
	#UWT_Line,
	#Siemens_Line {
		stroke-dasharray: 0;
	}

	.animation-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
		position: relative;

		@media (min-width: 1024px) {
			min-height: 75vh;
		}
		.ygen-logo {
			// position: absolute;
			// left: 50%;
			// top: 50%;
			// transform: translate(-39%,-39%);
			z-index: 5;
			position: relative;
		}

		.svg-animated-custom {
			transform-origin: left center;
			a {
				path {
				}

				&:hover {
					#Siemens_Logo {
					}
					#Cashco_Logo {
					}
				}
			}
		}

		.single-item-brand {
			position: absolute;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
			z-index: 4;
			opacity: 1;
			text-align: center;
			border-radius: 50%;

			a {
				//position: absolute;
				//inset: 0;
				//height: 100%;
				//width: 100%;
				//z-index: 1;
			}

			@keyframes __bounceInDown {
				0%,
				100% {
					transform: translateY(0);
				}
				50% {
					transform: translateY(10px);
				}
			}

			svg {
				animation: __bounceInDown 1s infinite ease-in-out;
				transition: ${theme.transition};
				cursor: pointer;
				box-shadow: 0 0 3px 4px #0000000f;
				border-radius: 50%;
				height: 110px;
			}

			&:hover {
				svg {
					height: 110px;
					width: 110px;
				}
			}
		}

		.single-item-brand:nth-child(1) svg {
			animation-delay: 0s;
		}

		.single-item-brand:nth-child(2) svg {
			animation-delay: 0.1s;
		}

		.single-item-brand:nth-child(3) svg {
			animation-delay: 0.2s;
		}

		.single-item-brand:nth-child(4) svg {
			animation-delay: 0.3s;
		}

		.single-item-brand:nth-child(5) svg {
			animation-delay: 0.4s;
		}

		.single-item-brand:nth-child(6) svg {
			animation-delay: 0.5s;
		}

		.single-item-brand:nth-child(7) svg {
			animation-delay: 0.6s;
		}

		.single-item-brand:nth-child(8) svg {
			animation-delay: 0.7s;
		}

		.single-item-brand:nth-child(9) svg {
			animation-delay: 0.8s;
		}

		.siemens {
			transform: translate(-339%, -267%);
		}

		.phoenix {
			transform: translate(-71%, -240%);
		}

		.pneucon {
			transform: translate(206%, -315%);
		}

		.jumo{
            transform: translate(393%,-234%);
		}
		.yokogawa {
			transform: translate(437%,-70%);
		}

		.beamex {
			transform: translate(356%, 143%);
		}

		.pentrair {
			transform: translate(98%, 182%);
		}

		.ebray {
			transform: translate(-197%, 176%);
		}

		.uwt {
			transform: translate(-465%, 151%);
		}

		.baumer {
			transform: translate(-395%, -71%);
		}

		#Logo_YGEN {
			transition: ${theme.transition};
			#Path_270 {
				transition: ${theme.transition};
			}

			&:hover {
				#Path_270 {
					fill: #dd223f;
				}
			}
		}
	}

	.image-wrapper {
		position: relative;

		svg {
			width: 100%;
			margin: auto;
			@media (max-width: 767px) {
				width: 100%;
			}
		}
	}

	@media (max-width: 767px) {
		padding-top: 80px;
		padding-bottom: 80px;
	}
`;
